import { t as SystemStatus } from "./status-ChiHYKYc.mjs";
import { t as getLogger } from "./logger-CpoV6RQj.mjs";

//#region src/i18n/constants.ts
/**
* Default language to use if no match is found
*/
const DEFAULT_LANGUAGE = "en-US";

//#endregion
//#region src/i18n/translations/en.ts
/**
* English (US) translations
*/
const enUS = {
	statusDetails: {
		[SystemStatus.Operational]: {
			title: "System Operational",
			message: "All systems are running normally."
		},
		[SystemStatus.DegradedPerformance]: {
			title: "Lower performance than usual",
			message: `We are currently facing a slowdown in performance than usual. Our team is working to restore normal speed.`
		},
		[SystemStatus.PartialOutage]: {
			title: "Certain features are unavailable",
			message: `Certain features are temporarily unavailable. We are working to restore full functionality as soon as possible.`
		},
		[SystemStatus.MajorOutage]: {
			title: "Platform is unavailable",
			message: `The platform is currently unavailable. We are working to fix this quickly and appreciate your understanding.`
		},
		[SystemStatus.UnderMaintenance]: {
			title: "Maintenance in progress",
			message: `We're updating our platform to serve you better. Brief interruptions may occur, but we'll be back to normal soon.`
		}
	},
	ui: { close: "Close" }
};
/**
* English (UK) translations
*/
const enGB = { ...enUS };

//#endregion
//#region src/i18n/i18n.ts
const logger = getLogger();
/**
* Mapping of supported languages to loader functions.
* Each loader returns a Promise resolving to the appropriate translation dictionary.
* Webpack magic comments ensure each chunk is lazy-loaded and named for clarity.
*/
const loadMap = {
	"en-US": () => Promise.resolve(enUS),
	"en-GB": () => Promise.resolve(enGB),
	"es-ES": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-es" */
		"./es-BF6RZJmn.mjs"
).then((m) => m.esES),
	"es-MX": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-es" */
		"./es-BF6RZJmn.mjs"
).then((m) => m.esMX),
	"es-AR": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-es" */
		"./es-BF6RZJmn.mjs"
).then((m) => m.esAR),
	"es-PE": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-es" */
		"./es-BF6RZJmn.mjs"
).then((m) => m.esPE),
	"es-CO": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-es" */
		"./es-BF6RZJmn.mjs"
).then((m) => m.esCO),
	"es-CL": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-es" */
		"./es-BF6RZJmn.mjs"
).then((m) => m.esCL),
	"pl-PL": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-pl" */
		"./pl-CWmyuT4J.mjs"
).then((m) => m.plPL),
	"de-DE": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-de" */
		"./de-bquBfrVj.mjs"
).then((m) => m.deDE),
	"it-IT": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-it" */
		"./it-CpOYfPnn.mjs"
).then((m) => m.itIT),
	"pt-BR": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-pt" */
		"./pt-BVvbCDwy.mjs"
).then((m) => m.ptBR),
	"pt-PT": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-pt" */
		"./pt-BVvbCDwy.mjs"
).then((m) => m.ptPT),
	"cs-CZ": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-cs" */
		"./cs-CYQ7C6db.mjs"
).then((m) => m.csCZ),
	"tr-TR": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-tr" */
		"./tr-DpHcwlg6.mjs"
).then((m) => m.trTR),
	"uk-UA": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-uk" */
		"./uk-BuBp-XLB.mjs"
).then((m) => m.ukUA),
	"fr-FR": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-fr" */
		"./fr-Da8xmYhg.mjs"
).then((m) => m.frFR),
	"fr-CA": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-fr" */
		"./fr-Da8xmYhg.mjs"
).then((m) => m.frCA),
	"zh-CN": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-zh" */
		"./zh-Coee2Szx.mjs"
).then((m) => m.zhCN),
	"zh-TW": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-zh" */
		"./zh-Coee2Szx.mjs"
).then((m) => m.zhTW),
	"zh-HK": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-zh" */
		"./zh-Coee2Szx.mjs"
).then((m) => m.zhHK),
	"zh-SG": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-zh" */
		"./zh-Coee2Szx.mjs"
).then((m) => m.zhSG),
	"ja-JP": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-ja" */
		"./ja-DUk1BQR_.mjs"
).then((m) => m.jaJP),
	"ko-KR": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-ko" */
		"./ko-CGH5ZPlu.mjs"
).then((m) => m.koKR),
	"nl-NL": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-nl" */
		"./nl-svP6iuWb.mjs"
).then((m) => m.nlNL),
	"nl-BE": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-nl" */
		"./nl-svP6iuWb.mjs"
).then((m) => m.nlBE),
	"sv-SE": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-sv" */
		"./sv-yWIL5lP8.mjs"
).then((m) => m.svSE),
	"nb-NO": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-nb" */
		"./nb-CbflpmRS.mjs"
).then((m) => m.nbNO),
	"ar-SA": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-ar" */
		"./ar-BpdJSC0K.mjs"
).then((m) => m.arSA),
	"hi-IN": () => import(
		/* webpackMode: "lazy" */
		/* webpackChunkName: "oops-widget-i18n-hi" */
		"./hi-Bk0omMnh.mjs"
).then((m) => m.hiIN)
};
const supportedLanguages = Object.keys(loadMap);
const cache = /* @__PURE__ */ new Map();
/**
* Load and cache a translation dictionary for a given language.
* Falls back to base language or default if necessary.
* @param lang - language code to load
* @returns translation dictionary
*/
async function loadTranslation(lang) {
	if (cache.has(lang)) return cache.get(lang);
	let dictionary;
	try {
		dictionary = await loadMap[lang]();
	} catch {
		const base = lang.split("-")[0];
		if (loadMap[base]) {
			logger.info(`Falling back ${lang} → ${base}`);
			dictionary = await loadMap[base]();
		} else {
			logger.warn(`No translation for ${lang}, using default ${DEFAULT_LANGUAGE}`);
			dictionary = await loadMap[DEFAULT_LANGUAGE]();
		}
	}
	cache.set(lang, dictionary);
	return dictionary;
}
/**
* Retrieve supported languages.
*/
function getSupportedLanguages() {
	return supportedLanguages;
}
/**
* Get status details text for a given system status and language.
* @param status - system status enum
* @param language - language code
*/
async function getStatusDetails(status, language) {
	const dict = await loadTranslation(language);
	return dict.statusDetails[status] ?? dict.statusDetails[SystemStatus.PartialOutage];
}
/**
* Get UI string for a specific key and language.
* @param key - UI string key
* @param language - language code
*/
async function getUIString(key, language) {
	return (await loadTranslation(language)).ui[key];
}
/**
* Create an I18nProvider with a fixed language.
* @param language - language code
*/
function createI18nProvider(language) {
	return {
		getStatusDetails: (status) => getStatusDetails(status, language),
		getUIString: (key) => getUIString(key, language),
		getSupportedLanguages
	};
}
/**
* Create an I18nProvider that auto-detects the user's browser language.
*/
function createAutoDetectI18nProvider() {
	return createI18nProvider(detectBrowserLanguage());
}

//#endregion
//#region src/i18n/detectLanguage.ts
/**
* Initialize language maps lazily to avoid potential issues with module initialization order
* and to ensure getSupportedLanguages() is only called when needed
*/
let exactMatchMap = null;
let baseLanguageMap = null;
/**
* Initializes the language maps if they haven't been initialized yet
*/
function ensureLanguageMapsInitialized() {
	if (exactMatchMap !== null && baseLanguageMap !== null) return;
	const supportedLanguages$1 = getSupportedLanguages();
	exactMatchMap = /* @__PURE__ */ new Map();
	baseLanguageMap = /* @__PURE__ */ new Map();
	for (const lang of supportedLanguages$1) {
		const normalizedLang = lang.toLowerCase();
		exactMatchMap.set(normalizedLang, lang);
		const base = normalizedLang.split("-")[0];
		if (!baseLanguageMap.has(base)) baseLanguageMap.set(base, lang);
	}
}
/**
* Detects the user's preferred language from the browser settings
* and maps it to one of our supported languages.
*
* @returns The detected language code that matches our supported languages.
*/
function detectBrowserLanguage() {
	if (typeof navigator === "undefined") return DEFAULT_LANGUAGE;
	const browserLanguages = navigator.languages || [navigator.language];
	if (!browserLanguages?.length) return DEFAULT_LANGUAGE;
	ensureLanguageMapsInitialized();
	for (const browserLang of browserLanguages) {
		if (!browserLang) continue;
		const normalizedLang = browserLang.replace(/_/g, "-").toLowerCase();
		const exactMatch = exactMatchMap.get(normalizedLang);
		if (exactMatch) return exactMatch;
		const langBase = normalizedLang.split("-")[0];
		const baseMatch = baseLanguageMap.get(langBase);
		if (baseMatch) return baseMatch;
	}
	return DEFAULT_LANGUAGE;
}
/**
* Force rebuilding of language maps (useful if supported languages change)
*/
function resetLanguageMaps() {
	exactMatchMap = null;
	baseLanguageMap = null;
}

//#endregion
export { DEFAULT_LANGUAGE, createAutoDetectI18nProvider, createI18nProvider, detectBrowserLanguage, resetLanguageMaps };